export const SET_DEPTHINFO = 'SET_DEPTHINFO';
export const SET_DEPTHINFO_SUCCESS = 'SET_DEPTHINFO_SUCCESS';
export const SET_FILTERITEMS = 'SET_FILTERITEMS';
export const SET_TEMPFILTERITEMS = 'SET_TEMPFILTERITEMS';
export const SET_SORTLISTBY = 'SET_SORTLISTBY';
export const SET_SWITCHLISTBY = 'SET_SWITCHLISTBY';
export const SET_TAGFILTERS_SHOW = 'SET_TAGFILTERS_SHOW';
export const SET_TEMPTAGFILTERS_SHOW = 'SET_TEMPTAGFILTERS_SHOW';

// search/GroupListInfoJson (取得熱銷與一般行程)

export const SET_GROUPLISTINFO = 'SET_GROUPLISTINFO';
export const SET_GROUPLISTINFO_SUCCESS = 'SET_GROUPLISTINFO_SUCCESS';
export const SET_GROUPLISTINFOM = 'SET_GROUPLISTINFOM';
export const SET_GROUPLISTINFOM_SUCCESS = 'SET_GROUPLISTINFOM_SUCCESS';
export const SET_SINGLEGROUPLISTINFO = 'SET_SINGLEGROUPLISTINFO';
export const SET_SINGLEGROUPLISTINFO_SUCCESS = 'SET_SINGLEGROUPLISTINFO_SUCCESS';
export const SET_SINGLEGROUPLISTINFOM = 'SET_SINGLEGROUPLISTINFOM';
export const SET_SINGLEGROUPLISTINFOM_SUCCESS = 'SET_SINGLEGROUPLISTINFOM_SUCCESS';
export const SET_PAGESIZEM = 'SET_PAGESIZEM';
export const SET_CHANGEITEM = 'SET_CHANGEITEM';
export const SET_TAGS = 'setTags';
export const SET_TRIGGER = 'SET_TRIGGER';
export const SET_CALLJSON = 'SET_CALLJSON';
